import React from 'react';
import PropTypes from 'prop-types';
import constants from '../../Constants';
import { Link } from 'react-router-dom';

/*
const AddButton = (props) => {
    const { onVehicleClick, sequence } = props;
    console.log(onVehicleClick);
    return (
        <button
            onClick={() => onVehicleClick(sequence)}
            className="btn btn-primary">
            Add
        </button>
    );
}
*/

const RemoveButton = (props) => {
    //const { onVehicleClick, sequence } = props;
    //console.log(onVehicleClick);
    return (
        <button
            //onClick={() => onVehicleClick(sequence)}
            className="btn btn-danger app-remove-btn">
            <i className={constants.icons.remove} />
            {` Remove`}
        </button>
    );
}

const VehicleItem = (props) => {
    const {id} = props;
    return (
        <div className="summary-list-item">
            <div className="row">
                <div className="col-md-6 item-data">
                    {props.name}
                    <div>
                    
                    <p style={{fontWeight:'normal'}}>4 CYL | Park Assist | Driver Assist</p>
                        
                    </div>
                </div>
                <div className="col-md-6">
                    <RemoveButton {...props} />

                    <Link
                        to={`vehicle/${id}`}
                        className="btn btn-secondary">
                        <i className={constants.icons.edit} />
                        {` Edit`}
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default VehicleItem;

VehicleItem.propTypes = {
    name: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/QuoteReview/vehicle/VehiclesItem.js